module.exports = __webpack_public_path__ + "assets/f863228bf99fd4ea97b13056b5f15232.mp3";